module.exports = __webpack_public_path__ + "static/media/notifyi-logo-light.917b54de.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/notifyi-logo-light.png
 ** module id = 782
 ** module chunks = 0
 **/